import { z } from 'zod';

export const ResearchRequestGraphSchema = z.object({
  researchRequestId: z.string(),
  nodes: z.array(
    z.object({
      id: z.string(),
      label: z.string(),
      type: z.enum([
        'researchRequest',
        'researchRequestQuery',
        'researchRequestHypothesis',
        'researchRequestEvidence',
        'source',
      ]),
    }),
  ),
  edges: z.array(
    z.object({
      source: z.string(),
      target: z.string(),
    }),
  ),
});

export type ResearchRequestGraph = z.infer<typeof ResearchRequestGraphSchema>;
